/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"
export default {
	listStorehouseForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => {
				if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
					dispatch("listStorehouseAllValues2").then(response => {
						resolve(response);
					})
				}
				else if (state.AppActiveUser.ROLE == "Company") dispatch("listStorehouseForCompany", state.AppActiveUser.companyid).then(response => {
					resolve(response);
				})

			})
	},
	updateStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		console.log(item)
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item.depotId)
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	addCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/ProductTracking/add/cargodefination", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	deleteCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/ProductTracking/delete/cargodefination/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/list/cargodefination", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CARGO_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listCargoForDepot({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/list/cargodefination/depotid/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CARGO_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				} else if (response.status == 400) {

					commit("CARGO_LIST", []);
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("CARGO_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	updateCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/ProductTracking/update/cargodefination", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/depotallow", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depotallow/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("DEPOTALLOW_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("DEPOTALLOW_LIST", []);
				}
				resolve(err.response);
			});
		});
	},
	deleteDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/depotallw/" + item.DepotCompanyId + "/" + item.DepotId + "?companyid=" + item.DepotCompanyId, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listUsingDepot({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/usingdepot", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				console.log(response)
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("USINGDEPOT_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depot", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseAllValues({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depot/all", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseAllValues2({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depot/all2", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {

					item = JSON.parse(response.data.json); 

					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOREHOUSE_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseForCompany({ commit }, item) {
		if (item == "company") item = state.AppActiveUser.companyid
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depot/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_COMPANY_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					commit("STOREHOUSE_COMPANY_LIST", []);

					router.push("/login")
				}
			}).catch(err => {
				commit("STOREHOUSE_COMPANY_LIST", []);

				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOREHOUSE_COMPANY_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},

	deleteStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/depot/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/storehouse", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/storehouselist", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseDetailForStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/storehouselist/depots/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSEDETAIL_LIST_FOR_STOREHOUSE", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	updateStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/storehouse", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	deleteStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/storehouse/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
}
